<template>
  <div v-if="hasAccess(MARKETING_MATERIALS_ACCESS, MARKETING_MATERIALS_ACCESS_MANAGE)"
       class="marketing-materials widgetInvoiceEstimate" ref="widgetInvoiceEstimate">
    <div class="header-commissions-group">
      <h1>Invoice / Estimate</h1>
    </div>
    <template v-if="pages && pages.length === 0">
      <notification-financing-page/>
    </template>
    <template v-else>
      <PageSelector />

      <div class="columns">
        <div class="column invoice-estimate-title">
          <p> Create an estimate to document the agreement with the client on the upcoming work and
            cost. Create an invoice to notify a customer that payment is due.
            Documents are uploaded in a PDF format for further sending to your client.
          </p>
        </div>
      </div>
      <PriceForm
        ref="invoiceEstimatePriceForm"
        :pageId="selectedPage ? selectedPage.id : null"
      />
    </template>

  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import * as CONTRACTOR_ACTIONS from '@/store/modules/contractor/actions';
import * as MUTATIONS from '@/store/mutations';
import NotificationFinancingPage from '@/components/NotificationFinancingPage.vue';
import PageSelector from '@/views/MarketingMaterials/components/PageSelector.vue';
import PriceForm from './InvoiceEstimateForm.vue';

export default {
  name: 'InvoiceEstimate',
  components: {
    PageSelector,
    PriceForm,
    NotificationFinancingPage,
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    ...mapState('contractor', { contractorId: (state) => state.id }),
    ...mapGetters(['hasAccess']),
    ...mapGetters('contractor', ['selectedPage', 'pages']),
  },
  data() {
    return {
      MARKETING_MATERIALS_ACCESS: { resource: 'marketing-materials', code: 'access' },
      MARKETING_MATERIALS_ACCESS_MANAGE: { resource: 'marketing-materials', code: 'manage_access' },
    };
  },
  methods: {
    ...mapActions('contractor', { updPages: CONTRACTOR_ACTIONS.LOAD_PAGES }),
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    ...mapActions('contractor', { setSelectedPage: CONTRACTOR_ACTIONS.SET_SELECTED_PAGE }),
  },
  async activated() {
    if (!this.contractorId) return;
    this.startLoading();

    try {
      if (!this.selectedPage?.id) {
        await this.updPages(this.contractorId);
      }

      if (this.selectedPage?.id) {
        this.$refs.invoiceEstimatePriceForm.resetForm();
      }

      window.scrollTo(0, 0);
    } catch (error) {
      this.$buefy.snackbar.open({
        message: 'An unexpected error occurred, please contact support@enhancify.com',
        actionText: ' ',
        position: 'is-top',
        indefinite: true,
        type: 'is-danger',
      });
    }

    this.finishLoading();
  },
};
</script>

<style lang="stylus" scoped>
.widgetInvoiceEstimate >>> .invoice-estimate-title
  max-width 860px
.header-commissions-group
  display flex
  column-gap 20px
  h2
    margin-top -10px
    @media screen and (max-width: 769px)
      margin-top 0
    @media screen and (max-width: 360px)
      margin-top 0
</style>
